import React, {useState} from 'react';
import styles from './delete-listing-modal-content.module.scss';
import {Row, Col, Button, Spinner} from "react-bootstrap";
import ListingService from '../../../../../../services/listing-service';
import { useHistory } from "react-router-dom";
import rejectIcon from "../../../../../../assets/order-summary-reject.svg"

const DeleteListingModalContent = ({applicationId, onClose}) => {
  const [ loading, setLoading ] = useState(false);
  const history = useHistory();
  const listingService = new ListingService();

  const deleteListingApplication = applicationId => {
    const service = async (applicationId) => {
      const _ = await listingService.deleteTermSheet(applicationId);
      setLoading(false);
      history.push('/listing/');
    }
    setLoading(true);
    service(applicationId);
  }

  return (
    <div className={styles['delete-listing']}>
      <Row>
        <Col lg={12}>
          <div>
            <h1>ARE YOU SURE YOU WANT TO DELETE THIS TERMSHEET?</h1>
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <div>
            <img alt="Delete" src={rejectIcon} />
          </div>
        </Col>
      </Row>
      <Row className={styles['button-row']}>
        <Col xs={6} lg={6}>
          <div className={styles['delete-button']}>
            <Button disabled={loading} onClick={()=>deleteListingApplication(applicationId)}>
              { loading ? <Spinner size="sm" animation="border" /> : 'DELETE' }
            </Button>
          </div>
        </Col>
        <Col xs={6} lg={6}>
          <div className={styles['cancel-button']}>
            <Button variant="secondary" onClick={()=>onClose()}>CANCEL</Button>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default DeleteListingModalContent;



